<script lang="ts">
  import { defineComponent } from "vue";
  import FileGridItemTemplate from "./FileGridItemTemplate";

  export default defineComponent({
    template: FileGridItemTemplate,
  });
</script>
